import { CREATED_AT, UID } from 'shared/api/query/constants';
import { accountSlug as accountSlugConfig } from 'shared/api/query/configs.json';

export const children = [
  { attr: UID },
  { attr: CREATED_AT },
  { attr: accountSlugConfig.edges.slug, default: '' },
];
